import React from "react";
import { Link, useParams } from "react-router-dom";
import { useGlobalContext } from "../context";

const SingleCocktail = () => {
  const { id } = useParams();
  const { tempCocktails } = useGlobalContext();

  const newCocktail = tempCocktails.filter((item) => {
    if (item.id === id) {
      return item;
    }
  });

  const {
    image,
    name,
    info,
    glass,
    ingredient1,
    ingredient2,
    ingredient3,
    ingredient4,
    ingredient5,
    instructions,
  } = newCocktail[0];

  return (
    <div className="single-info">
      <img src={image} alt="" />
      <div className="info">
        <span>
          <h4>Name: </h4>
          {name}
        </span>
        <span>
          <h4>Info: </h4>
          {info}
        </span>
        <span>
          <h4>Glass: </h4>
          {glass}
        </span>
        <span>
          <h4>Ingredients: </h4>
          {`${ingredient1 ? `${ingredient1}` : ""} ${
            ingredient2 ? `, ${ingredient2}` : ""
          } ${ingredient3 ? `, ${ingredient3}` : ""} ${
            ingredient4 ? `, ${ingredient4}` : ""
          } ${ingredient5 ? `, ${ingredient5}` : ""}`}
        </span>
        <span>
          <h4>Instructions: </h4>
          {instructions}
        </span>
        <div className="btns">
          <Link to="/cocktails" className="btn">
            Back
          </Link>
          <Link to="/" className="btn">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SingleCocktail;
